"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var Item_1 = require("@features/ItemLogPage/components/OverallList/Item");
var react_1 = __importDefault(require("react"));
var Header_1 = require("./Header");
function Table(_a) {
    var order = _a.order, onSortOrderChange = _a.onSortOrderChange, displayQueue = _a.displayQueue, items = _a.items, openRulesAndHistoryModal = _a.openRulesAndHistoryModal, angularJsDependencies = _a.angularJsDependencies;
    return (react_1.default.createElement("table", { className: "ng-table table jobs-table" },
        items && items.length > 0 && react_1.default.createElement(Header_1.Header, { order: order, onSortOrderChange: onSortOrderChange, displayQueue: displayQueue }),
        react_1.default.createElement("tbody", null, items &&
            items.map(function (item, index) { return (react_1.default.createElement(Item_1.Item, { key: index, job: item, imagesMetadata: item.imagesMetadataArray || [], videosMetadata: item.videosMetadataArray || [], openRulesAndHistoryModal: openRulesAndHistoryModal, angularJsDependencies: angularJsDependencies, displayQueue: displayQueue })); }))));
}
exports.Table = Table;
